
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "stretch": "stretch-7489698d",
    "fit": "fit-7489698d"
};
exports.styleSource = ".stretch-7489698d{flex:auto;position:relative}.fit-7489698d{width:100%;height:100%}.fit-7489698d>div{position:absolute;top:0;left:0;width:100%;height:100%}";
exports.default = exports.styles;
            
module.moduleType = "style";
